function setCookie(name: string, value: string, days: number = 7) {
    try {
        const d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        const cookieValue = encodeURIComponent(value);
        const cookieString = `${name}=${cookieValue}; expires=${d.toUTCString()}; path=/`;
        document.cookie = cookieString;
        console.log('Cookie set successfully:', {
            name,
            value: value.substring(0, 20) + '...',
            expires: d.toUTCString()
        });
        return true;
    } catch (error) {
        console.error('Error setting cookie:', error);
        return false;
    }
}

function getCookie(name: string): string | null {
    try {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                const value = decodeURIComponent(c.substring(nameEQ.length, c.length));
                console.log('Cookie found:', { name, value: value.substring(0, 20) + '...' });
                return value;
            }
        }
        console.log('Cookie not found:', name);
        return null;
    } catch (error) {
        console.error('Error getting cookie:', error);
        return null;
    }
}

function deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    console.log('Cookie deleted:', name);
}

function debugCookies() {
    console.group('Cookie Debug Info');
    console.log('Document cookie string:', document.cookie);
    
    const cookies: Record<string, string> = {};
    document.cookie.split(';').forEach(cookie => {
        const [name, value] = cookie.trim().split('=');
        if (name) cookies[name] = value;
    });
    
    console.log('Parsed cookies:', cookies);
    console.log('Token cookie:', getCookie('token'));
    console.groupEnd();
}

export { setCookie, getCookie, deleteCookie, debugCookies };